import * as React from 'react';
import { Button, ButtonVariant } from '@components/molecules';
import { cn } from '@utils';

interface MailToLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	link: string;
}
const MailToLink = React.forwardRef<HTMLButtonElement, MailToLinkProps>(
	({ className, link, children, ...props }, ref) => {
		return (
			<Button
				ref={ref}
				asChild
				variant={ButtonVariant.HYPERLINK}
				className={cn('p-0 h-0', className)}
				{...props}
				data-aid="email-to-button"
			>
				<a href={`mailto:${link}`} target="_blank" rel="noreferrer" className="hover:underline!">
					{children}
				</a>
			</Button>
		);
	}
);
MailToLink.displayName = 'MailToLink';

export { MailToLink };
